export default __webpack_public_path__ + "static/area-with-negative-values-9d9c60a2c94ed21040dbc61b89151cee.png";